import { render, staticRenderFns } from "./showcase-edit-layout.vue?vue&type=template&id=5f3b015f&scoped=true"
import script from "./showcase-edit-layout.ts?vue&type=script&lang=ts&external"
export * from "./showcase-edit-layout.ts?vue&type=script&lang=ts&external"
import style0 from "./showcase-edit-layout.scss?vue&type=style&index=0&id=5f3b015f&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3b015f",
  null
  
)

export default component.exports